const state = {
    moldUseInformationFields: [
        {
            key: "code",
            label: "零件編號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "seriesNo",
            label: "零件序號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "name",
            label: "零件名稱",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "used_life",
            label: "累積使用壽命",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "standard_life",
            label: "標準壽命",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        }
    ],
    moldUseInformationItem: [],
}
const getters = {
    get_moldUseInformationFields: state => {
        return state.moldUseInformationFields
    },
    get_moldUseInformationItem: state => {
        return state.moldUseInformationItem
    },
}
const actions = {
    set_moldUseInformationFields(context, array) {
        context.commit('SET_MOLDUSEINFORMATIONFIELDS', array);
    },
    set_moldUseInformationItem(context, array) {
        context.commit('SET_MOLDUSEINFORMATIONITEM', array);
    },
    clear_moldUseInformationItem(context) {
        context.commit('CLEAR_MOLDUSEINFORMATIONITEM');
    },
}
const mutations = {
    SET_MOLDUSEINFORMATIONFIELDS(state, array) {
        state.moldUseInformationItem = array;
    },
    SET_MOLDUSEINFORMATIONITEM(state, array) {
        state.moldUseInformationItem = array;
    },
    CLEAR_MOLDUSEINFORMATIONITEM(state) {
        state.moldUseInformationItem = [];
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/moldUseInformation.js